import { useCallback } from 'react';

const useScrollToRefOnMount = () => {
  return useCallback((node: HTMLDivElement | HTMLHeadingElement) => {
    if (!node) return;

    setTimeout(() => {
      node.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }, []);
};

export default useScrollToRefOnMount;
